<template>
  <div id="dataset-period">
    <div class="row" v-if="!hideTwoPeriods">
      <div class="col-xs-12">
        <label>
          <input type="checkbox" id="checkbox"
                 v-model="twoPeriods" @change="update">
          La surveillance a été réalisée sur deux périodes disjointes
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-xs-12 date-control">
        <div class="input-group">
          <div class="input-group-addon">
            Début
          </div>
          <div class="form-control text-center">
            <dropdown class="date-picker" dropup :disabled="disabled">
              <a class="dropdown-toggle" role="button" :disabled="disabled">
                <i class="glyphicon glyphicon-calendar"></i>
                <strong>{{ dateDisplay.date.start }}</strong>
              </a>
              <template slot="dropdown">
                <li class="dropdown-in-modal">
                  <date-picker v-model="date.start"
                               @input="update"
                               :clear-btn="false"
                               :limit-from="limits.start.from"
                               :limit-to="limits.start.to"/>
                </li>
              </template>
            </dropdown>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 date-control">
        <div class="input-group">
          <div class="input-group-addon">
            Fin
          </div>
          <div class="form-control text-center">
            <dropdown class="date-picker dropdown-in-modal" dropup :disabled="disabled">
              <a class="dropdown-toggle" role="button" :disabled="disabled">
                <i class="glyphicon glyphicon-calendar"></i>
                <strong>{{ dateDisplay.date.end }}</strong>
              </a>
              <template slot="dropdown">
                <li>
                  <date-picker v-model="date.end"
                               @input="update"
                               :clear-btn="false"
                               :limit-from="limits.end.from"
                               :limit-to="limits.end.to"/>
                </li>
              </template>
            </dropdown>
          </div>
        </div>
      </div>
      <div class="col-xs-12" v-if="date.error !== ''">
        <span class="text-danger help-block">{{ date.error }}</span>
      </div>
    </div>
    <div class="date-row" v-if="twoPeriods">
      <div class="row">
        <div class="col-md-6 col-xs-12 date-control">
          <div class="input-group">
            <div class="input-group-addon">
              Début
            </div>
            <div class="form-control text-center">
              <dropdown class="date-picker dropdown-in-modal" dropup :disabled="disabled">
                <a class="dropdown-toggle" role="button" :disabled="disabled">
                  <i class="glyphicon glyphicon-calendar"></i>
                  <strong>{{ dateDisplay.date2.start }}</strong>
                </a>
                <template slot="dropdown">
                  <li>
                    <date-picker v-model="date2.start"
                                 @input="update"
                                 :clear-btn="false"
                                 :limit-from="limits.start.from"
                                 :limit-to="limits.start.to"/>
                  </li>
                </template>
              </dropdown>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 date-control">
          <div class="input-group">
            <div class="input-group-addon">
              Fin
            </div>
            <div class="form-control text-center">
              <dropdown class="date-picker dropdown-in-modal" dropup :disabled="disabled">
                <a class="dropdown-toggle" role="button" :disabled="disabled">
                  <i class="glyphicon glyphicon-calendar"></i>
                  <strong>{{ dateDisplay.date2.end }}</strong>
                </a>
                <template slot="dropdown">
                  <li>
                    <date-picker v-model="date2.end"
                                 @input="update"
                                 :clear-btn="false"
                                 :limit-from="limits.end.from"
                                 :limit-to="limits.end.to"/>
                  </li>
                </template>
              </dropdown>
            </div>
          </div>
        </div>
        <div class="col-xs-12" v-if="date2.error !== ''">
          <span class="text-danger help-block">{{ date2.error }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'dataset-period',
  props: {
    value: {
      type: Object,
      required: true
    },

    limits: {
      type: Object,
      required: true
    },

    defaults: {
      type: Object,
      required: true
    },

    hideTwoPeriods: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    const d = this.defaults
    return {
      unit: '',
      twoPeriods: false,
      date: { start: d.start, end: d.end, error: '' },
      date2: { start: d.start, end: d.end, error: '' }
    }
  },

  watch: {
    value: function (v) {
      this.fill()
    }
  },

  mounted: function () {
    this.fill()
  },

  computed: {
    dateDisplay: function () {
      const f = (d) => moment(d).format('DD/MM/YYYY')
      const d = (d) => { return { start: f(d.start), end: f(d.end) } }
      const result = {
        date: d(this.date),
        date2: d(this.date2)
      }
      return result
    }
  },

  methods: {
    fill: function () {
      const v = this.value
      this.unit = v.unit
      this.date.start = v.date.start
      this.date.end = v.date.end
      this.date2.start = v.date2.start
      this.date2.end = v.date2.end
      this.twoPeriods = v.twoPeriods
      this.checkDates()
    },

    checkDates: function () {
      const cd = (d) => {
        const f = moment(d.start)
        const s = moment(d.end)
        if (f >= s) {
          d.error = 'La date de début doit être inférieure à la date de fin'
        }
      }

      this.date.error = ''
      this.date2.error = ''
      cd(this.date)
      const count = (d) => {
        return moment(d.end).diff(moment(d.start), 'days')
      }

      let sum = count(this.date)
      if (this.twoPeriods) {
        sum += count(this.date2)
        cd(this.date2)
        const f = moment(this.date.end)
        const s = moment(this.date2.start)
        if (f >= s) {
          this.date.error = this.date2.error =
            'La première période doit être strictement antérieure à la seconde'
        }
      }

      if (this.limits.sum == null) {
        return
      }

      const { low, high } = this.limits.sum
      const error = sum < low
        ? `La surveillance doit s'étendre sur au moins ${low} jours (les dates
choisies s'étendent sur ${sum} jours seulement)`
        : sum > high ? `La surveillance doit s'étendre sur au plus ${high} jours
(les dates choisies s'étendent sur ${sum} jours)`
          : null
      if (error != null) {
        const e = (d, e) => { if (d.error === '') { d.error = e } }
        e(this.date, error)
        if (this.twoPeriods) {
          e(this.date2, error)
        }
      }
    },

    update: function () {
      this.checkDates()
      this.$emit(
        'input',
        {
          unit: this.unit,
          twoPeriods: this.twoPeriods,
          date: {
            start: this.date.start, end: this.date.end, error: this.date.error
          },
          date2: {
            start: this.date2.start, end: this.date2.end, error: this.date2.error
          }
        }
      )
    }
  }
}
</script>
<style lang="less" scoped>
@import '~variables';

.has-error .control-label {
  color: @brand-danger;
}

.has-error .help-block {
  color: @brand-danger;
}

.glyphicon-calendar {
  margin-right: 0.4rem;
}

.date-row {
  margin-top: 1rem;
}

.date-control {
  .dropdown-toggle {
    box-shadow: none;
  }

  .dropdown-toggle[disabled] {
    cursor: not-allowed;
    opacity: 0.60;

    &:hover {
      text-decoration: none;
    }
  }

  .input-group-addon {
    min-width: 8rem;
  }
}
</style>
